import {React, useState} from 'react'
import Autosuggest from 'react-autosuggest';
import './input.css'
import styles from "./Input-style.module.css";
import { useEffect } from 'react';


function AutoSuggest({
    label,
    elementConfig,
    onChangeField,
    value,
    isValid,
    errorMsg,
    name,
    Maxlength
}) {

const [suggestions, setSuggestions] = useState([]);
const [valuecheck, setValueCheck] = useState(value);
const [labelFocus, setLabelFocus] = useState(false);

useEffect(() => {
 setValueCheck(value)
}, [])


const getSuggestions = (value) => {
    const inputValue = value?.trim().toLowerCase();
    const inputLength = inputValue.length;
  
    return inputLength === 0 ? [] : elementConfig.filter(data =>
      data.value.toLowerCase().slice(0, inputLength) === inputValue
    );
  };
  const onChangeEvent = (event, { newValue }) =>{
    setValueCheck(newValue);
  }

  const onSuggestionsFetchRequested = ({ value, reason }) => {
    if(reason == 'input-focused' || valuecheck !=''){
        setLabelFocus(true)
    }

    setSuggestions(getSuggestions(value));
    if(reason == 'suggestion-selected'){
        onChangeField(name, value, true)
    }else{
        onChangeField(name, value, false)
    }
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const getSuggestionValue = suggestion => suggestion.value;

  const renderSuggestion = suggestion => (
    <div>
      {suggestion.value}
    </div>
  );

  const outOfFous = () => {
        setLabelFocus(false);
  }

  return (
    <div className={`intro-y g-col-12 g-col-md-6 g-col-xl-4 px-8 ${!isValid && 'validInput'} `}>
        <div className={styles.form__group} onBlur={outOfFous}>
            <Autosuggest 
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                inputProps={{value:valuecheck, onChange:onChangeEvent, maxLength:Maxlength}}
                alwaysRenderSuggestions={true}
                />
          
                  <label onClick={()=>{setLabelFocus(true)}}
                className={labelFocus ? 'input_focus' : `${valuecheck != '' ?  'input_Open_check' :'input_Open' }` }
              >
                {label}
              </label>
              <span
                className={`${!isValid ? styles.errorMsg : styles.errorMsgnot}`}
              >
                {errorMsg}
              </span>
        </div>
     </div>
  )
}

export default AutoSuggest